var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.6522C2 12.292 2.31236 12 2.69767 12H18.9767C20.6464 12 22 13.2653 22 14.8261C22 15.3983 21.8181 15.9309 21.5053 16.3759C21.7916 16.4571 22 16.7058 22 17C22 17.3602 21.6876 17.6522 21.3023 17.6522H20.1395V20.6957H21.3023C21.6876 20.6957 22 20.9876 22 21.3478C22 21.708 21.6876 22 21.3023 22H5.02326C3.35356 22 2 20.7347 2 19.1739C2 18.6017 2.18195 18.0692 2.49471 17.6241C2.20839 17.5429 2 17.2942 2 17C2 16.6398 2.31236 16.3478 2.69767 16.3478H3.86047V13.3043H2.69767C2.31236 13.3043 2 13.0124 2 12.6522Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1846 10.9257C12.0641 10.8919 11.9359 10.8919 11.8154 10.9257C10.4059 11.32 8.79152 10.106 8.20964 8.21397C7.62777 6.32194 8.2987 4.46858 9.7082 4.0743C10.4783 3.85882 11.3094 4.12337 12 4.71633C12.6906 4.12337 13.5217 3.85882 14.2918 4.0743C15.7013 4.46858 16.3722 6.32194 15.7904 8.21397C15.2085 10.106 13.5941 11.32 12.1846 10.9257Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8668 3.21446C14.953 2.9758 15 2.71839 15 2.45001C15 2.20147 14.7985 2 14.55 2H14.25C13.3069 2 12.4994 2.58019 12.1648 3.4031C12.8878 3.02782 13.7214 2.87614 14.5613 3.11114C14.6665 3.14058 14.7683 3.17514 14.8668 3.21446Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.278e6bdc745c1ae38616c645d56730f6.svg";
export { ForwardRef as ReactComponent };